import type { ComponentType } from 'react';

const displayName = <P extends object>(WrappedComponent: ComponentType<P>) =>
  WrappedComponent.displayName || WrappedComponent.name;

export default displayName;
